import { BoltIcon, ShieldCheckIcon } from "@heroicons/react/20/solid";

export default function ProtectionIcon({ isThirdParty }: { isThirdParty: boolean }) {
    if (isThirdParty)
        return <span className="text-warn-400 mr-1"><BoltIcon className="h-4 w-4" /></span>
    else
        return <span className="text-pcx-400 mr-1"><ShieldCheckIcon className="h-4 w-4" /></span>
}